// @ts-nocheck
import * as actions from './pagesActions';
import reducer from './pagesReducer';
import * as selectors from './pagesSelectors';

export { actions, reducer, selectors };
